<template>
  <div class="ApplicationFilter" v-if="items && value">
    <v-avatar size="48" :color="selectedFilter.color">
      <v-icon :size="selectedFilter.size || '32'" color="white"
        >$vuetify.icons.{{ selectedFilter.icon }}</v-icon
      >
    </v-avatar>

    <v-select
      v-model="selectedFilter"
      @change="filterChanged"
      :items="items"
      return-object
      :menu-props="{ maxWidth: 300, bottom: true, offsetY: true }"
      class="custom"
    >
      <template v-slot:selection="{ item }">
        <div>
          <div class="text-selection-title primary--text">
            <h1>{{ item.text }}</h1>
          </div>
          <div class="text-selection-subtitle" v-if="totalApplications != null">
            <span 
              >{{ totalApplications }} total
            </span>
          </div>
        </div>
      </template>

      <template v-slot:item="{ item }">
        <div class="application-status">
          <v-icon size="22" left>$vuetify.icons.{{ item.icon }}</v-icon>
          {{ item.text }}
        </div>
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  name: 'ApplicationFilter',
  props: {
    value: {
      type: String,
      default: null
    },
    items: {
      type: Array,
      default: () => []
    },
    totalApplications: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      selectedFilter: this.items[0]
    }
  },
  watch: {
    value() {
      this.selectedFilter =
        this.items.find(i => i.value === this.value) || this.items[0] || {}
      document.title = this.selectedFilter.text + ' | EA Application'
    }
  },
  methods: {
    filterChanged(newValue) {
      this.$emit('input', newValue.value)
    }
  },
  created() {
    document.title = this.selectedFilter.text + ' | Emergency Assistence'
  }
}
</script>

<style scoped lang="scss">
.ApplicationFilter {
  display: flex;

  .v-avatar {
    overflow: hidden;
  }
}

::v-deep .custom {
  &.v-text-field {
    margin-left: 1rem;
    padding-top: 0;
  }

  &.v-text-field > .v-input__control > .v-input__slot {
    &::before,
    &::after {
      border-style: none;
    }
  }

  &.v-input--is-focused {
    &.v-text-field > .v-input__control > .v-input__slot {
      i.v-icon {
        border-radius: 50%;
        background-color: $grey-4;
      }
    }
  }

  .v-select__selections .text-selection-title h1 {
    font-size: 2rem;
    line-height: 1;
  }

  .v-select__selections .text-selection-subtitle {
    color: rgba(0, 0, 0, 0.54);
  }

  .v-input__append-inner .v-icon {
    color: $color-primary;
  }
}
</style>
